import store from "../store";

function normalizeWithAr(episode) {
  const factor = Math.min(Math.pow(store.ar, 1.7), 5);
  const minX = 3.5 + 2 - factor,
    maxX = 20.5 - 2 + factor,
    minY = 2.5,
    maxY = 12;
  return normalize(episode, minX, maxX, minY, maxY);
}

function normalize(episode, minX, maxX, minY, maxY) {
  const episodeCopy = [...episode];
  const xValues = episodeCopy.map((level) => level[0]);
  const yValues = episodeCopy.map((level) => level[1]);
  const minX_ = Math.min(...xValues);
  const maxX_ = Math.max(...xValues);
  const minY_ = Math.min(...yValues);
  const maxY_ = Math.max(...yValues);
  for (const level of episodeCopy) {
    level[0] = ((level[0] - minX_) / (maxX_ - minX_)) * (maxX - minX) + minX;
    level[1] = ((level[1] - minY_) / (maxY_ - minY_)) * (maxY - minY) + minY;
  }
  return episodeCopy;
}

const EPISODES = [
  // 1
  [
    [3.5, 3],
    [3, 8.5],
    [7.2, 7.5],
    [9.5, 11.5],
    [11.5, 7.5],
    [10, 3.5],
    [15, 3.5],
    [17.5, 6.5],
    [16.5, 11],
    [21, 9],
    [22, 3],
    [25.5, 6.5],
  ],
  // 2
  [
    [3, 10.5],
    [4.5, 7],
    [9 + 1.5, 4],
    // [14, 3.5],
    [19.5 - 1.5, 3],
    [3 + 22, 2],
    [10 + 21.5, 3.5],
    [17 + 9, 7.5 - 0.5],
    [21 - 1, 8.5 - 1],
    [10.5 + 3, 7.5],
    [7.5 + 3, 11],
    [13 + 6, 12],
    // [3.5 + 23, 8.5],
    [9.5 + 22 - 3 - 1, 11.5 - 0.5],
    [11.5 + 22 - 1, 7.5 + 1],
    [7.2 + 22 + 8 - 1, 7.5 - 1.5],
  ],
  // 3
  [
    [3, 5],
    [7.5, 3],
    [6.5, 7.5],
    [9, 11],
    [14, 11.5],
    [12.5, 7.5],
    [14.5, 3.5],
    [16.8, 7.5],
    [21, 5.5],
    [20.5, 11.5],
    [11.5 + 14 - 1, 7.5 + 1],
    [7.2 + 14 + 8 - 3, 7.5 - 3.5],
  ],
  // 4
  [
    [3, 4.5],
    [4.5, 11],
    [7 + 1, 6.5],
    [9 + 1, 3.5],
    [11.5 + 1, 7.5],
    [10 + 1, 11.5],
    [15 + 1, 10],
    [19.5 + 1, 10.5],
    [16.5 + 1, 6.5],
    [16.5 + 1, 3],
    [22.5 + 1, 3.5],
    [25 + 1, 8.5],
  ],
  // 5
  [
    [2, 8.5],
    [4, 2],
    [7.2, 7],
    [9.5, 11.5],
    [12, 7.5],
    [10, 3.5],
    [14.5, 3.5],
    [3.5 + 23 - 7, 8.5 - 6],
    [17.5, 6.5],
    [15.5, 11],
    [21, 9],
    [9.5 + 22 - 3 - 5, 11.5 - 6],
    [11.5 + 22 - 1 - 4.5, 7.5 - 5],
    [7.2 + 22 - 4 - 1 + 8 - 3.5, 7.5 - 1.5 + 2],
  ],
];
export const NUM_EPISODES = EPISODES.length;

export function getEpisode(episodeIdx) {
  if (episodeIdx >= NUM_EPISODES) return null;
  return normalizeWithAr(EPISODES[episodeIdx]);
}

export function getEpisodeIdx(levelIdx) {
  let episodeIdx = 0;
  let levelCount = EPISODES[episodeIdx].length;
  while (levelIdx >= levelCount) {
    episodeIdx++;
    if (episodeIdx >= NUM_EPISODES) return NUM_EPISODES;
    levelCount += EPISODES[episodeIdx].length;
  }
  return episodeIdx;
}

export function getLevelIdx(episodeIdx) {
  if (episodeIdx > NUM_EPISODES) return null;
  let levelIdx = 0;
  while (episodeIdx > 0) {
    episodeIdx--;
    levelIdx += EPISODES[episodeIdx].length;
  }
  return levelIdx;
}
